const navbarStyle = {
  backgroundColor: "#66CDAA",
  boxShadow: "0 5px 6px rgba(0, 0, 0, 0.2)",
};

export default navbarStyle;
